export const REWARD_LIST = "REWARD_LIST";
export const FAVORITE_LIST = "FAVORITE_LIST";
export const FAVORITE = "FAVORITE";
export const CART_LIST = "CART_LIST";
export const CART_ADD = "CART_ADD";
export const CART_UPDATE = "CART_UPDATE";
export const CHECKOUT = "CHECKOUT";
